// extracted by mini-css-extract-plugin
module.exports = {"badgeAdditional":"PosSyncPageHeader_badgeAdditional__334V1"};